import { LocPrefixService } from "../../LocationPrefixEditor/LocationPrefixService";

export const getAssetMilepost = (asset) => {
  return asset.start;
};

export const getAssetMilepostWithPrefix = (asset, inspecLineId) => {
  function prefix_plus_mp(prefix, mp) {
    return prefix === "" || !prefix ? mp : `${prefix} ${mp}`;
  }
  let startPrefix = LocPrefixService.getPrefixMp(asset.start, inspecLineId);
  if (asset.start === asset.end || !asset.end) return prefix_plus_mp(startPrefix, asset.start);

  let endPrefix = LocPrefixService.getPrefixMp(asset.start, inspecLineId);
  return `${prefix_plus_mp(startPrefix, asset.start)} - ${prefix_plus_mp(startPrefix, asset.end)}`;
};

export const getAssetMilepostWithPrefixFromStartEnd = (inspecLineId, start, end) => {
  function prefix_plus_mp(prefix, mp) {
    return prefix === "" ? mp : `${prefix} ${mp}`;
  }
  let startPrefix = LocPrefixService.getPrefixMp(start, inspecLineId);
  if (start === end || !end) return prefix_plus_mp(startPrefix, start);

  return `${prefix_plus_mp(startPrefix, start)} - ${prefix_plus_mp(startPrefix, end)}`;
};

export const getStartEndMilepostWithPrefix = (inspecLineId, start, end) => {
  function prefix_plus_mp(prefix, mp) {
    return prefix === "" ? mp : `${prefix} ${mp}`;
  }
  let startPrefix = LocPrefixService.getPrefixMp(start, inspecLineId);

  return { start: String(prefix_plus_mp(startPrefix, start)), end: String(prefix_plus_mp(startPrefix, end)) };
};

export const getAssetMarkerCombined = (unit) => {
  if (unit.startMarker && unit.endMarker) return null;
  return Array.from(
    new Set(
      [unit.startMarker, unit.endMarker]
        .filter((m) => m)
        .map((m) => m.trim())
        .filter((m) => m !== ""),
    ),
  ).join(" - ");
};



// WEBPACK FOOTER //
// ./src/components/Reports/utils/getAssetMileport.js